<template>
  <div class="dialog-container wt-dialog-container ">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" ></wt-form-table>
    <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'GoodsPutInRecord',
  isAutoComponent: true,
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      detailFormButtons: {
        title: '入库记录',
        elements: [{ name: '取消', key: 'CLOSE', action: 'CLOSE' }]
      },
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULES_GOODS',
        formComponent: {
          list: { type: 'default', value: '/modules/goods/goodsPutList' }
        },
        formInputsData: [
          { name: '采购单号', key: 'goodsNum', value: '', type: 'text' },
          { name: '操作人', key: 'operateUserName', value: '', type: 'text' },
          { name: '操作时间', key: 'createTimeRange', value: [], type: 'datetime' }],
        formButtonsData: [],
        formTableData: [
          { name: '商品编号', key: 'goodsNum', type: 'text' },
          { name: '入库明细', key: 'putDetail', type: 'text' },
          { name: '数量', key: 'count', type: 'text' },
          { name: '单价', key: 'price', type: 'text' },
          { name: '小计', key: 'subtotal', type: 'text' },
          { name: '采购日期', key: 'evaluationTime', type: 'text' },
          { name: '入库日期', key: 'putTime', type: 'text' },
          { name: '采购单号', key: 'evaluationNum', type: 'text' },
          { name: '供应商', key: 'supplier', type: 'text' },
          { name: '入库仓库', key: 'warehouse', type: 'text' },
          // { name: '商品名称', key: 'goodsName', type: 'text' },
          { name: '备注', key: 'remark', type: 'text' }
          // { name: '操作时间', key: 'createTime', type: 'text' },
          // { name: '操作人', key: 'operateUserName', type: 'text' }],
        ],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { buttonHidden: true, index: true }
      },
      goodsRecordVisible: false
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      }
    },
    onButtonAction(data) {
    }
  }
}
</script>
